@for (col of columns();  track col) {
  <td
    [style.height]="col.height || '60px'"
    [ngClass]="{ 'associated-entity-id': col.field === 'associatedEntityId' }"
    (click)="clicked(row(), col)"
    >
    @if (col.editable && row().editMode) {
      <form #rowForm [formGroup]="form">
        <mat-form-field appearance="outline">
          <input
            #input
            matInput
            maxlength="{{ col.maxlength }}"
            autocomplete="no-autofill"
            [formControlName]="col.field"
            [placeholder]="col.header | translate"
            value="{{ row() | dataCellFormatter: col }}"
            (keyup.enter)="submit()"
            (blur)="submit()"
            />
          </mat-form-field>
          @if (col.maxlength) {
            <div>
              <mat-hint>{{ input.value?.length || 0 }}/{{ col.maxlength }}</mat-hint>
            </div>
          }
        </form>
      } @else {
        <!-- PRESENTATIONAL CELL -->
        @if (col.checkbox) {
          <miq-tableCheckbox [value]="row()" [disabled]="col.disabled"></miq-tableCheckbox>
        }
        <p class="data-row">
          @if (col.toggler) {
            @if (col.toggler.indent) {
              <span [miqIndent]="row().level"></span>
            }
            @if (row().isContainer) {
              <span class="container-icon">
                @if (row().expanded && col.toggler.expand_icon) {
                  <mat-icon
                    [svgIcon]="col.toggler.expand_icon"
                    [style.width]="col.toggler.width || '24px'"
                  ></mat-icon>
                }
                @if (!row().expanded && col.toggler.expanded_icon) {
                  <mat-icon
                    [svgIcon]="col.toggler.expanded_icon"
                    [style.width]="col.toggler.width || '24px'"
                  ></mat-icon>
                }
              </span>
            }
          }
          @if (!row().isContainer && col.link) {
            <a (click)="col.link.command(row())">{{ col.link.text || row() | dataCellFormatter: col }}</a>
          } @else {
            {{ row() | dataCellFormatter: col }}
          }
        </p>
        @if (col.subtitleCellFormater) {
          <p class="subtitle-text">
            @if (col.toggler && col.toggler.indent) {
              <span [miqIndent]="row().level"></span>
              }{{ row() | subtitleCellFormater: col }}
            </p>
          }
        }
      </td>
    }
